import { useParams, Link } from 'react-router-dom';
import { useGeneralExams, useExamStats } from '../lib/api';
import type { ExamSectionStat } from '../lib/api';

export function ExamTopicsPage() {
  const { examId } = useParams();
  const { data: examsData } = useGeneralExams();
  const { data: statsData } = useExamStats(examId ?? null);

  const exam = examsData?.exams?.find(e => e.id === examId);
  const stats = statsData?.stats;

  return (
    <div className="max-w-lg mx-auto px-4 pb-20">
      {/* Header */}
      <div className="flex items-center gap-3 pt-2 mb-5">
        <Link to={`/exam/${examId}`} className="text-squishy-primary">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
            <path fillRule="evenodd" d="M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z" clipRule="evenodd" />
          </svg>
        </Link>
        <div>
          <h1 className="text-xl font-bold text-squishy-dark">All Topics</h1>
          {exam && <p className="text-xs text-slate-500">{exam.code}</p>}
        </div>
      </div>

      {stats && stats.sections.length > 0 ? (
        <div className="space-y-2">
          {stats.sections.map(s => (
            <TopicRow key={s.sectionId} stat={s} />
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-slate-400 text-sm">No topics available.</div>
      )}
    </div>
  );
}

function TopicRow({ stat }: { stat: ExamSectionStat }) {
  const progress = stat.totalQuestions > 0 ? Math.round((stat.attempted / stat.totalQuestions) * 100) : 0;

  return (
    <div className="bg-white border rounded-xl p-4">
      <div className="flex items-baseline gap-2">
        <span className="font-semibold text-sm text-squishy-dark truncate">{stat.sectionName}</span>
        <span className="text-[10px] text-slate-400 uppercase">{stat.sectionCode}</span>
      </div>
      <div className="flex items-center gap-3 mt-1.5">
        <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-teal-400 to-emerald-500 rounded-full transition-all duration-700"
            style={{ width: `${progress}%` }}
          />
        </div>
        <span className="text-[10px] text-slate-500 shrink-0">{stat.attempted}/{stat.totalQuestions}</span>
      </div>
      <div className="text-[10px] text-slate-400 mt-1">
        {stat.accuracy}% accuracy
      </div>
    </div>
  );
}
